import { render } from "./Add.vue?vue&type=template&id=a0a5371c"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"
script.render = render

export default script